// extracted by mini-css-extract-plugin
module.exports = {"dotsWrap":"dotsWrap__1AOJX","axis":"axis__2aOTU","axisText":"axisText__1JlDE","dots":"dots__2_5ZK","isVisible":"isVisible__1mfUE"};